/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_USER_URL, COMMON_HEADER_CONFIG} from "../config";

class PermissionService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchPermissions = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/permissions`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 1000,
          page: 1,
          ...data
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListPermissions = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/permissions`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 1000,
          page: 1
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListPermissionsByUser = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/user/${id}/permissions`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListObjectPermissions = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/objects`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 1000,
          page: 1
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListActionPermissions = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/action`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 1000,
          page: 1
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOnePermission = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/permission/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createPermission = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_USER_URL}/permission`,
        data,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updatePermission = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify({
        ...data,
        active: true
        // platform_code: "centralweb"
      });
      const config = {
        method: "put",
        url: `${API_USER_URL}/permission/${data.id}`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateRoleOfPermission = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_USER_URL}/permission/add-for-multi-role`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateActivePermission = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify({
        ...data,
        active: !data.active
      });
      const config = {
        method: "put",
        url: `${API_USER_URL}/permission/${data.id}`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deletePermission = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_USER_URL}/permission/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === 1 || response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
}

const permissionService = new PermissionService();

export default permissionService;
